import React, { HTMLAttributes } from 'react';
import '../heading/heading.scss';
/* eslint-disable-next-line */

export interface HeadingVariantProps extends HTMLAttributes<HTMLHeadElement> {
  type?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | string;
  children: React.ReactNode;
  ariaLevel?: string;
  isOnHomeBanner?: boolean;
  className?: string;
}

/**
 * This component accepts configuration based on the parent component invoking it. The component configures the heading tag based on the requirement of the block that uses this.
 * @param props
 * @returns template of heading
 */
export function HeadingVariant(props: HeadingVariantProps) {
  const { type = 'h2', children, ariaLevel, ...rest } = props;
  const elements = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6'
  };
  const tag = type?.toLowerCase() as keyof typeof elements;
  const isValidVarient = Object.values(elements).includes(tag);
  const headingTag = isValidVarient ? elements[tag] : elements.h2;

  let { className } = rest;
  const role = 'heading';
  const arialevel = ariaLevel || '1';
  const fontStyles = '!font-frutiger font-bold set-frutiger';

  className = `${fontStyles} ${className}`;

  return React.createElement(
    headingTag,
    { ...rest, className, role, 'aria-level': arialevel },
    children
  );
}
